import {axiosGet} from "../../../Helpers/AxiosHelper";

const state = {
    fundList: []
};

const getters = {
    getFund: state => state.fundList
};

const actions = {
    getFund({commit}) {
        axiosGet(`crm/funds?all`).then(({data}) => {
            commit('FUND_INFO', data)
        }).catch((error) => console.log(error));
    },
};

const mutations = {
    FUND_INFO(state, data) {
        state.fundList = data;
    }
};


export default {
    state,
    getters,
    actions,
    mutations
}
